<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="产品名称/UDI编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称/UDI编码" v-model="searchParam"></a-input>
                </a-form-item>
              </a-col>

              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

                </a-col>
              </span>

            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <!-- 操作按钮区域 -->

        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
            :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
            :pagination="ipagination" :scroll="{ x: `${columns.length}0%`, y: 500 }" :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
            @change="handleTableChange" style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <a type="primary" @click="getDetail(record)">详情</a>
              <a-divider type="vertical" />
              <a type="primary"  @click="handleExportXls('文件', record)">导出</a>
            </span>
            <template slot="switch" slot-scope="text, record">
              <a-switch v-model="record.button" @change="switchOnChange(record,$event)" ></a-switch>
            </template>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="state" slot-scope="state">
              <a-tag v-if="state === 0" color="blue">待审核</a-tag>
              <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
              <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
              <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
            </template>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <afVerificationRecordDetail ref="modalDetail" @ok="modalDetailOk" @close="modalDetailClose"></afVerificationRecordDetail>
        <!-- <piRecordList ref="modalDetail" @ok="modalDetailOk" @close="modalDetailClose"></piRecordList> -->
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
import afVerificationRecordDetail from './modules/afVerificationRecordDetail'
// import piRecordList from '../UDIadmin/modules/PIreorcd.vue'
import { ledgerDelete, getAfVerificationList, rcRecordSwitch} from '@/api/api'
import JDate from '@/components/jeecg/JDate'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { PIadmin } from '@/api/manage'
import { getNowFormatStr } from '@/utils/util'

export default {
  name: 'RetailOutList',
  mixins: [JeecgListMixin],
  components: {
    afVerificationRecordDetail,
    JDate,
  },
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 查询条件
      // queryParam: {
      //   // productName: ''

      // },
      button: false,
      searchParam: '',
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '产品名称', dataIndex: 'productName', width: 220 ,ellipsis: true, render: (text) => text || "--" },
        { title: '产品DI', dataIndex: 'productDi', width: 200, render: (text) => text || "--" },
        { title: '生产批号', dataIndex: 'batchNumber',width: 150, render: (text) => text || "--"},
        { title: '生产日期', dataIndex: 'startDate', width: 150, render: (text) => text || "--" },
        { title: '灭菌批号', dataIndex: 'batchNo',width: 150, render: (text) => text || "--"},
        { title: '失效日期', dataIndex: 'endDate',width: 150, render: (text) => text || "--" },
        { title: '有效期', dataIndex: 'effectiveDate',width: 150, render: (text) => text || "--"},
        { title: 'UDI码数量', dataIndex: 'codeNum', width: 100, render: (text) => text || "--" },
        { title: '生成时间', dataIndex: 'createTime',render: (text) => text || "--"},
        { title: '防伪验证', dataIndex: 'button',key: 'button',width: 100, scopedSlots: { customRender: 'switch' },fixed: 'right', },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/productPi/piList',

      },
      ///productPi/exportPiSecurityExcelByPiId
      ul: {
        toExcel: 'productPi/exportPiSecurityExcelByPiId'
      }
    }
  },
  computed: {},
  created() {

  },
  methods: {
    //getAfVerificationList
    async getList() {
      let params = {
        // id : record.uuid
      }
      const res = await getAfVerificationList(params)
      if (res.code == 200 && res.success == true) {
        this.dataSource = res.data.list
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
    // 查询
    // searchQuery(){
    //   console.log('ooo')
    // },
    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    //打开详情
    getDetail(record){
      console.log(record,'详细信息=======================')
      this.$refs.modalDetail.getlist(record)
    },
    modalDetailOk(){

    },
    modalDetailClose(){

    },
    // 导出
    handleExportXls(fileName, res) {
      console.log(fileName,res,'0909090')
      let params = {
        id: res.id
      }
      if (!fileName || typeof fileName != "string") {
        fileName = "导出文件"
      }
      let searchObj = {}
      // searchObj.search = JSON.stringify(this.queryParam)
      searchObj.search = this.searchParam
      PIadmin(this.ul.toExcel, params).then((data) => {
        console.log(data,'===============data============')
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '_' + getNowFormatStr() + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },
    // 开关
    async switchOnChange(record,e){ //rcRecordSwitch

      console.log(record,e,'开关状态=======================')
      let params = {
        button : e,
        udiProductPiId : record.id
      }
      const res = await rcRecordSwitch(params)
      console.log(res,'=============res===============')
      if(res.data == 20 && res.errmsg == '成功'){
        console.log(res.data,'=============res.data===============')
        // this.userStatus = !this.userStatus
        // this.button = !this.button
        this.loadData()
      }
    },
    addLicense(record){
      console.log(record,'详细信息=======================')
      this.$refs.modalLicense.initShow(record)
    },

    //删除handleDelete
    async handleDelete(record) {
      let params = {
        id : record.uuid
      }
      const res = await ledgerDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>